/**
 * Company Details API Hooks
 */

import { useQuery } from "@tanstack/react-query";
import config from "@/lib/config";

const COMPANY_KEYS = {
  all: ["company-details"] as const,
  detail: () => [...COMPANY_KEYS.all, "detail"] as const,
};

async function fetchWithAuth(url: string) {
  const token = localStorage.getItem("auth-data");
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const response = await fetch(`${config.apiUrl}${url}`, {
    headers,
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Failed to fetch company details");
  }

  return response.json();
}

export interface CompanyDetails {
  id: string;
  userId: string;
  companyName: string;
  email: string;
  taxNumber?: string;
  vatId?: string;
  country: string;
  street?: string;
  postalCode?: string;
  city?: string;
  website?: string;
  contactFirstName?: string;
  contactLastName?: string;
  contactEmail?: string;
  contactPhone?: string;
  iban?: string;
  bic?: string;
  bankName?: string;
}

export function useCompanyDetails() {
  return useQuery<CompanyDetails>({
    queryKey: COMPANY_KEYS.detail(),
    queryFn: () => fetchWithAuth("/api/company-details"),
  });
}
